<section class="account-section" aria-labelledby="account-personal">
  <h2 id="account-personal">Osobné údaje</h2>
  <form [formRoot]="form" class="account-form">
    <div class="names">
      <mat-form-field appearance="outline">
        <mat-label>Meno</mat-label>
        <input matInput autocomplete="given-name" [formField]="form.firstName" />
        <mat-error [seiriFieldError]="form.firstName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Priezvisko</mat-label>
        <input matInput autocomplete="family-name" [formField]="form.lastName" />
        <mat-error [seiriFieldError]="form.lastName" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Telefón</mat-label>
      <input matInput type="tel" autocomplete="tel" [formField]="form.phone" />
      <mat-error [seiriFieldError]="form.phone" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Dátum narodenia</mat-label>
      <input matInput autocomplete="bday" [matDatepicker]="birthDate" [formField]="form.birthDate" />
      <mat-datepicker-toggle matSuffix [for]="birthDate" />
      <mat-datepicker #birthDate startView="multi-year" />
      <mat-error [seiriFieldError]="form.birthDate" />
    </mat-form-field>

    <div class="gender">
      <span id="account-gender" class="gender-label">Pohlavie</span>
      <mat-radio-group aria-labelledby="account-gender" color="primary" [formField]="form.gender">
        <mat-radio-button [value]="Gender.Male">Muž</mat-radio-button>
        <mat-radio-button [value]="Gender.Female">Žena</mat-radio-button>
        <mat-radio-button [value]="null">Neuvádzam</mat-radio-button>
      </mat-radio-group>
    </div>

    <seiri-save-bar
      [changed]="changed()"
      [invalid]="form().invalid()"
      [submitting]="form().submitting()"
      [problem]="problem(form().errorSummary())"
      (discard)="discard()"
    />
  </form>
</section>

<section class="account-section" aria-labelledby="account-sign-in">
  <h2 id="account-sign-in">Prihlásenie a zabezpečenie</h2>
  @if (pendingEmail(); as pendingEmail) {
    <div class="callout callout--warning" role="status">
      <mat-icon aria-hidden="true">schedule</mat-icon>
      <span>
        Zmena e-mailu na <strong class="pending-address">{{ pendingEmail }}</strong> čaká na potvrdenie. Otvorte odkaz,
        ktorý sme na túto adresu poslali; platí {{ linkHours }} hodín. Dovtedy sa prihlasujete súčasným e-mailom.
      </span>
    </div>
  }
  <ng-content select="[accountEmailHint]" />
  <ul class="account-rows">
    <li class="account-row">
      <div class="row-text">
        <span class="label">E-mail na prihlásenie</span>
        <span class="value">{{ email() }}</span>
      </div>
      @if (pendingEmail()) {
        <button type="button" mat-stroked-button [disabled]="cancelling()" (click)="cancelEmailChange()">
          Zrušiť zmenu
        </button>
      } @else {
        <button type="button" mat-stroked-button (click)="changeEmail()">Zmeniť e-mail</button>
      }
    </li>
    <li class="account-row">
      <div class="row-text">
        <span class="label">Heslo</span>
        <span class="value" aria-label="Heslo je nastavené">••••••••</span>
      </div>
      <button type="button" mat-stroked-button (click)="changePassword()">Zmeniť heslo</button>
    </li>
  </ul>
</section>
